<template>
  <v-layout column>
    <v-btn to="add-vendor" color="primary" class="mb-2">
      Add a vendor
    </v-btn>
    <vendor
      v-for="vend in vendors"
      :key="vend.id"
      :vendor="vend"
      class="my-2"
      @remove="confirm"
    />
    <v-divider class="my-1" />
    <v-data-table :headers="headers" :items="orders" class="mt-2">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.createdAt | formatDate }}</td>
        <td>{{ props.item.createdBy }}</td>
        <td>{{ props.item.description }}</td>
        <td>{{ props.item.status }}</td>
        <td>
          <v-btn
            :color="props.item.status == 'open' ? 'error' : 'success'"
            @click="
              updateStatus(
                props.item.id,
                props.item.status == 'open' ? 'closed' : 'open'
              )
            "
          >
            {{ props.item.status == 'open' ? 'finish' : 're-open' }}
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" width="250">
      <v-card>
        <v-card-title class="headline red">
          Confirm Delete
        </v-card-title>
        <v-card-text>Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-layout justify-space-around>
            <v-btn @click="dialog = false">
              Back
            </v-btn>
            <v-btn color="error" @click="remove">
              Delete
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import dayjs from 'dayjs';
import Vendor from './Vendor.vue';

const userRef = db.collection('users').doc(getUid());

export default {
  name: 'Maintenence',
  components: { Vendor },
  filters: {
    formatDate: date => date && dayjs(date).format('h:mm A MM/DD/YYYY'),
  },
  data: () => ({
    dialog: false,
    vendorToRemove: null,
    vendors: [],
    orders: [],
    headers: [
      {
        text: 'Date',
        align: 'left',
        value: 'createdAt',
      },
      {
        text: 'Tenant',
        value: 'createdBy',
      },
      {
        text: 'Request',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
      },
    ],
  }),
  methods: {
    confirm(key) {
      this.vendorToRemove = key;
      this.dialog = true;
    },
    async remove() {
      await this.$firestoreRefs.vendors.doc(this.vendorToRemove).delete();
      this.vendorToRemove = null;
      this.dialog = false;
    },
    async updateStatus(key, status) {
      await db
        .collection('orders')
        .doc(key)
        .update({ status });
    },
  },
  firestore: () => ({
    vendors: userRef.collection('vendors'),
    orders: db.collection('orders').where('admin', '==', getUid()),
  }),
};
</script>

<style></style>
